// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Popper.module.scss  */
.Popper-module-Root_3Pv {
  z-index: 1;
  box-sizing: border-box;
  animation-duration: 0.4s;
  isolation: isolate; }

.Popper-module-Root_3Pv[aria-hidden='false'] {
  animation-name: Popper-module-fadeIn_itB; }

.Popper-module-Root_3Pv[aria-hidden='true'] {
  display: none; }

@keyframes Popper-module-fadeIn_itB {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Popper/Popper.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,UAAU;EACV,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB,EAAE;;AAEtB;EACE,wCAAwC,EAAE;;AAE5C;EACE,aAAa,EAAE;;AAEjB;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE","sourcesContent":["/*  imported from Popper.module.scss  */\n.Popper-module-Root_3Pv {\n  z-index: 1;\n  box-sizing: border-box;\n  animation-duration: 0.4s;\n  isolation: isolate; }\n\n.Popper-module-Root_3Pv[aria-hidden='false'] {\n  animation-name: Popper-module-fadeIn_itB; }\n\n.Popper-module-Root_3Pv[aria-hidden='true'] {\n  display: none; }\n\n@keyframes Popper-module-fadeIn_itB {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
